<template>
  <ul class="main navigation flex gap-8">
    <!-- <li><router-link :to="'/om'">{{ $t('Header.Button01') }}</router-link></li> -->
    <!-- <li><router-link :to="'/kompass'">{{ $t('Header.Button02') }}</router-link></li> -->
    <li v-if="user"><router-link :to="'/mine-projekter'">{{ $t('Header.Button03') }}</router-link></li>
    <li v-if="user && !hasAccessToBokvalitet"><router-link :to="'/ams'">{{ $t('Header.Button06') }}</router-link></li>
    <li v-if="(isAdmin || isSuperAdmin) && !hasAccessToBokvalitet"><router-link :to="'/gms'">{{ $t('Header.Button14') }}</router-link></li>
    <li
      v-if="isSuperAdmin || isAdmin"
      @click="toggleAdminMenu"
      class="relative cursor-pointer"
    >
      <span>{{ $t('Header.AdminMenuLabel') }}</span>
      <ul v-if="showAdminMenu" class="absolute top-10 p-2" style="background-color: #999">
        <li v-if="isSuperAdmin || (isAdmin && organizationAllowsChildren)"><router-link :to="'/admin/organizations'"><span class="whitespace-nowrap">{{ $t('Header.Button08') }}</span></router-link></li>
        <li v-if="isSuperAdmin || isAdmin"><router-link :to="'/admin/users'"><span class="whitespace-nowrap">{{ $t('Header.Button09') }}</span></router-link></li>
        <li v-if="canAdministerBokvalitet"><router-link :to="'/framework-manager'"><span class="whitespace-nowrap">{{ $t('Header.Button11') }}</span></router-link></li>
        <li v-if="isSuperAdmin"><router-link :to="'/cms'"><span class="whitespace-nowrap">{{ $t('Header.Button07') }}</span></router-link></li>
        <li v-if="isSuperAdmin"><router-link :to="'/frameworks'"><span class="whitespace-nowrap">{{ $t('Header.Button13') }}</span></router-link></li>
        <li v-if="isSuperAdmin || isAdmin"><router-link :to="'/admin/license-requests'"><span class="whitespace-nowrap">{{ $t('Bokvalitetsrosen.license_requests.License Requests') }}</span></router-link></li>
    </ul>
    </li>
    <li v-if="!isLink"><router-link to="/support">{{ $t('Header.Button10') }}</router-link></li>
    <li v-if="!isLink">
      <router-link :to="{ path: '/', hash: '#abonnement-og-priser' }">Abonnement</router-link>
    </li>
    <!-- <li v-if="user"><router-link :to="'/'">Min Profil</router-link></li> -->
  </ul>
</template>

<script>
import { isLinkKompassOrigin } from '@/composables/domainUtils'

export default {
  data () {
    return {
      showAdminMenu: false,
    }
  },
  computed: {
    isLink () {
      return isLinkKompassOrigin()
    },
    user () {
      return this.$store.state.auth.user
    },
    isSuperAdmin () {
      return this.$store.getters['auth/isAuthenticated'] && this.$store.getters['auth/user'].roleId === 3
    },
    isAdmin () {
      return this.$store.getters['auth/isAuthenticated'] && this.$store.getters['auth/user'].roleId === 4
    },
    hasAccessToBokvalitet () {
      const framework = this.$store.getters['frameworks/list']
        .filter(framework => this.$store.getters['auth/user'].frameworkIds.includes(framework.id))
        .find(framework => framework.id === 4)
      if (!framework || framework.length === 0) return false
      return true
    },
    canAdministerBokvalitet () {
      return this.isSuperAdmin || (this.isAdmin && this.hasAccessToBokvalitet && this.organizationAllowsChildren)
    },
    organizationAllowsChildren () {
      const user = this.$store.getters['auth/user']
      if (!user) return false
      if (user?.roleId === 2) return false
      const organization = this.$store.getters['organizations/get'](user.organizationId)
      if (!organization) return false
      console.log('organization', organization)
      return organization.allowChildren
    },
  },
  methods: {
    toggleAdminMenu () {
      this.showAdminMenu = !this.showAdminMenu
    },
  },
  async mounted () {
    if (this.user && this.user.organizationId) {
      const response = await this.$store.dispatch('organizations/get', this.user.organizationId)
      console.log('organization', response)
    }
  },
}
</script>

<style scoped>
li a.router-link-active {
  border-bottom: 1px solid currentColor;
}
</style>
